import SubCardConnected from './SubCardConnected'

export default SubCardConnected
